/**
 * @description Sticky header height
 * @module stickyHeaderHeightMap
 * @category config
 */

import {
    EXTRA_LARGE,
    LARGE,
    MEDIUM,
    SMALL
} from 'widgets/toolbox/viewtype';

export const stickyHeaderHeightMap = {
    [SMALL]: 104,
    [MEDIUM]: 104,
    [LARGE]: 120,
    [EXTRA_LARGE]: 120
};
